<script>
import { bApp, isWeCom, isMiniBankInsurance } from 'base/config'

export default {
  name: 'BaseLayer',
  props: {
    isGaokeAgent: Boolean,
    isPolicyCheck: Boolean,
    isSchemeShow: Boolean,
    isTrade: Boolean,
    isShowThemePicker: Boolean
  },
  data () {
    this.bApp = bApp
    this.isWeCom = isWeCom
    this.isMiniBankInsurance = isMiniBankInsurance
    return {}
  },
  methods: {
    handleClick (typeName) {
      this.$emit('invoke', typeName)
    }
  }
}
</script>
<template>
  <div class="base-layer">
    <template v-if="isPolicyCheck">
      <a
        class="btn save primary"
        href="javascript:;"
        @click="handleClick('save')"
      >保存</a>
      <a
        v-if="!isWeCom && !isMiniBankInsurance && !isGaokeAgent"
        class="btn generate"
        href="javascript:;"
        @click="handleClick('generate-image')"
      >导出图片</a>
      <a
        class="btn share"
        data-stat-id="share_bottom"
        @click="handleClick('share')"
      >分享</a>
    </template>
    <template v-else>
      <a
        v-if="isShowThemePicker"
        class="btn theme-picker"
        href="javascript:;"
        data-stat-id="theme_picker_bottom"
        @click="handleClick('openThemePicker')"
      >换肤</a>
      <a
        class="btn generate"
        href="javascript:;"
        data-stat-id="wendang"
        @click="handleClick('generate')"
      >导出文档</a>
      <a
        v-if="!isWeCom"
        class="btn generate"
        href="javascript:;"
        @click="handleClick('generate-image')"
      >导出图表</a>
      <a
        v-if="isSchemeShow"
        class="btn interpretation"
        href="javascript:;"
        @click="handleClick('interpretation')"
      >讲解方案</a>
      <template v-if="bApp">
        <a
          v-if="isTrade"
          class="btn insured"
          href="javascript:;"
          @click="handleClick('insured')"
        >立即投保</a>
        <a
          v-else
          class="btn share primary"
          data-stat-id="share_bottom"
          @click="handleClick('share')"
        >分享</a>
      </template>
    </template>
  </div>
</template>
<style lang="postcss" scoped>
.base-layer {
  display: flex;
  flex: 2;
  .btn {
    display: block;
    flex: 1;
    line-height: 34px;
    border-radius: 0.12rem;
    border: 1px solid #ccc;
    margin-left: 0.2rem;
    white-space: nowrap;
    &:first-child {
      margin-left: 0;
    }
  }

  .btn:first-child:nth-last-child(n+5),
  .btn:first-child:nth-last-child(n+5) ~ .btn {
    font-size: 93%;
  }
}
</style>
